/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getDeliveryErrors(campaignId) {
    return axios.get(`${this.url}/${campaignId}/delivery_errors`);
  }

  previewImport(formData) {
    return axios.post(`${this.url}/preview_import`, formData);
  }

  getCampaignContacts(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/contacts`, { params });
  }

  getAnalytics(campaignId) {
    return axios.get(`${this.url}/${campaignId}/analytics`);
  }

  exportContacts(campaignId) {
    return axios.get(`${this.url}/${campaignId}/contacts`, {
      params: { export: 'csv' },
      responseType: 'blob',
    });
  }

  downloadImportErrors(campaignId) {
    return axios.get(`${this.url}/${campaignId}/import_errors`, {
      responseType: 'blob',
    });
  }

  retarget(campaignId, payload) {
    return axios.post(`${this.url}/${campaignId}/retarget`, payload);
  }

  pause(campaignId) {
    return axios.put(`${this.url}/${campaignId}/pause`);
  }

  resume(campaignId) {
    return axios.put(`${this.url}/${campaignId}/resume`);
  }

  stop(campaignId) {
    return axios.put(`${this.url}/${campaignId}/stop`);
  }
}

export default new CampaignsAPI();
